import { DomElement, ViewStream } from "spyne";
import { ModalWindowTraits } from "traits/modal-window-traits";
import { PageDocItemsTraits } from "traits/page-doc-items-traits";
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import { PageDocsItemsExternalTraits } from "traits/page-docs-items-external-traits";
import { CodeSampleTraits } from "traits/code-sample-traits";
import { UtilTraits } from "traits/util-traits";
import hljs from "highlight.js";
import { PageDocsItemBlockCardCallout } from "components/pages/page-docs-item-block-card-callout";
import {PageDocsTraits} from 'traits/page-docs-traits';
import {ScrollSpyTraits} from 'traits/scroll-spy-traits';
import {PageDocsItemBlock} from 'components/pages/page-docs-item-block';

import ModalWindowTmpl from "./templates/ui-modal-window-content.tmpl.html";
import ModalWindowMsgTmpl from "./templates/ui-modal-window-content-message.tmpl.html";

export class UiModalWindowContent extends ViewStream {
  constructor(props = {}) {
    props.class = `modal-window-content modal-${props.modalType}`;
    props.traits = [
      PageDocsTraits,
      PageDocItemsTraits,
      ScrollSpyTraits,
      PageLoadDocsTraits,
      ModalWindowTraits
    ];
  //console.log("content props data", props.data, props);
    props.template = props.modalType === 'message' ? ModalWindowMsgTmpl : ModalWindowTmpl;
    props.pageId = "configure";
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_MODAL_WINDOW_CHANGE_EVENT", "disposeViewStream"]];
  }

  onRemoveModal(e){
    //window.setTimeout(this.disposeViewStream.bind(this), 300);
  }


  onAddBlocks(modalType) {
    const { pageId } = this.props;
    const addBlockItem = (data, blockNum) => {
      const parentVsid = this.props.id;

      const { blockType } = data;
      //console.log("ADD THE BLOKS ",{blockType, pageId, data: JSON.stringify(data)}, this.props);

      //console.log("blockType ",{blockType,data})

      //if (blockType === 'heading') {

      const appendElSel = modalType === 'window' ? ".modal-window-content-block" : ".modal-window-content-body";

      this.appendView(
          new PageDocsItemBlock({ data, blockNum, pageId, parentVsid }),  appendElSel
      );
      //}
    };

    this.props.data.block.forEach(addBlockItem);
  }


  updateRoutesConfigExample(){

    const configExampleElsArr = this.props.el$(".routes-config-example code span").arr;
   //console.log("ROUTE CONFIG ARR ",configExampleElsArr);

    const updateSpansIfMatch = (spanEl) =>{
      const isRoutes = spanEl.innerText === `"routes"`;
      const isRoutePath = spanEl.innerText === `"routePath"`;
     //console.log("SPAN EL IS ",spanEl);
      if (isRoutes){
        spanEl.classList = 'hljs-number';
      } else if (isRoutePath){
        spanEl.classList = 'hljs-array';
      }
    }

    configExampleElsArr.forEach(updateSpansIfMatch);


  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    const { modalType } = this.props;

    this.modalWindow$AddBodyContent(modalType);

    if (this.props.data.block) {
      this.onAddBlocks(modalType);
      //window.setTimeout( this.onAddBlocks.bind(this), 500);
    }

    if (modalType === 'route'){
      requestAnimationFrame(this.updateRoutesConfigExample.bind(this));
    }

    this.addChannel("CHANNEL_MODAL_WINDOW");
  }
}
